export default {
      id: "small-priority-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "sprite-46b249.svg#small-priority-usage",
      toString: function () {
        return this.url;
      }
    }